<template>
  <div class="line-chart-container">
    <div :id="chartDomId" class="chart-dom" :style="{ width: '100%', height: lineHeight + 'px' }"></div>
    <div class="legend-container">
      <div class="legend-item" v-for="item in seriesData" :key="item.name">
        <div class="legend-item-color" :style="{ backgroundColor: item.color }"></div>
        <div class="legend-item-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import icons from '@/components/IconSelect/requireIcons';
import * as echarts from 'echarts'

export default {
  name: 'ScreenLineChart',
  props: {
    axisData: { type: Array, default: () => [] },
    seriesData: { type: Array, default: () => [] },
    lineHeight: { type: Number, default: 200 }
  },
  data() {
    return {
      chartDomId: 'echarts-line-' + Math.random().toString(36).slice(2, 9),
      chartInstance: null,
      resizeObserver: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
    if (this.chartInstance) this.chartInstance.dispose()
  },
  methods: {
    initChart() {
      this.$nextTick(() => {
        const el = document.getElementById(this.chartDomId)
        if (!el) return
        requestAnimationFrame(() => {
          if (!this.chartInstance) this.chartInstance = echarts.init(el)
          this.runSetOption()
          this.chartInstance.resize()
          this.resizeObserver = new ResizeObserver(() => this.chartInstance && this.chartInstance.resize())
          this.resizeObserver.observe(el)
          setTimeout(() => this.chartInstance && this.chartInstance.resize(), 80)
        })
      })
    },
    runSetOption() {
      if (!this.chartInstance) return
      let colors = this.seriesData.map(item => item.color);
      const seriesData = this.seriesData.map(item => ({
        name: item.name,
        type: 'line',
        smooth: true,
        showSymbol: false,
        data: item.data,
        lineStyle: { color: item.color },
        areaStyle: item.showArea ? {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: item.color },
            { offset: 1, color: 'rgba(51, 173, 71, 0.1)' }
          ])
        } : null
      }))
      const option = {
        grid: { left: 20, right: 20, top: 0, bottom: 25 },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: 'category',
          data: this.axisData,
          boundaryGap: false,
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold',
            color: '#9292C1'
          }
        },
        yAxis: {
          type: 'value',
          splitLine: { lineStyle: { type: 'dashed', color: '#5A5A89' } },
          axisLabel: { fontSize: 10, fontWeight: 'bold', fontFamily: 'Arial', color: '#9292C1' }
        },
        series: seriesData
      }
      this.chartInstance.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.line-chart-container {
  width: 100%;
  padding-top: 20px;
  box-sizing: border-box;

  .legend-container {
    display: flex;
    padding-top: 10px;
    justify-content: flex-end;
    align-items: center;
    gap: 19px;

    .legend-item {
      display: inline-flex;
      align-items: center;
      gap: 6px;

      .legend-item-color {
        width: 11px;
        height: 11px;
        border-radius: 50%;
      }

      .legend-item-name {
        font-size: 12px;
        color: #9292C1;
      }
    }
  }
}

.chart-dom {
  width: 100%;
  padding: 0;
  box-sizing: border-box;
}
</style>
